import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import PaymentForm from "./payment-form";
import PaymentSuccess from "./payment-success";
// import axios from "../../middleware/axios";

import { useParams, useNavigate } from "react-router-dom";
import { OrderDbType, OrderPrductItem } from "../../models/order_model";
import { getOrderApi } from "../../middleware/order-functions";
import { formatNumber } from "../../middleware/common-functions";
import { fauth } from "../../middleware/firebase";
/// test cards
/// Masterdcard 5474 9254 3267 0366 | 123}  11/30
/// Masterdcard Debito 5579 0534 6148 2647 | 1234 | 11/30
/// Visa 4075 5957 1648 3764 | 123 | 11/30

declare global {
  interface Window {
    Payment: any;
  }
}

const PaymentPage: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const { order_id } = useParams<{ order_id: string }>();
  const [error_message, setError_message] = useState<string | null>(null);
  const [order, setOrder_data] = useState<OrderDbType | null>();
  const [user] = useAuthState(fauth);
  const history = useNavigate();

  useEffect(() => {
    getOrder(order_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_id]);

  const getOrder = async (order_id: string) => {
    try {
      const set_order = await getOrderApi(order_id);
      if (set_order) {
        // Add doc_id to the order data
        const orderWithId = { ...set_order, doc_id: order_id };
        setOrder_data(orderWithId);
      }
    } catch (error) {
      setError_message(
        "Error al cargar la orden. Por favor, intente nuevamente."
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "200px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  const paymentSuccess = (is_paid: boolean, order_obj: OrderDbType) => {
    const set_order = { ...order, ...order_obj, doc_id: order_id };
    if (is_paid) {
      set_order.is_paid = true;
    }
    setOrder_data(set_order);
  };

  if (!order) {
    return (
      <div className="alert alert-danger" role="alert">
        No se pudo cargar la información de la orden. Por favor, intente
        nuevamente.
      </div>
    );
  }

  // If order is already paid, redirect to order details
  if (order.is_paid && window.location.pathname.includes("/pago/")) {
    history(`/cuenta/orden/${order_id}`);
    return null;
  }

  return (
    <div className="first-container last-container payment_page container">
      <h2>Paga tu orden {order_id}</h2>

      {error_message && (
        <div
          className="alert alert-danger alert-dismissible fade show"
          role="alert"
        >
          {error_message}
          <button
            type="button"
            className="btn-close"
            onClick={() => setError_message(null)}
            aria-label="Close"
          ></button>
        </div>
      )}

      <div className="row">
        <div className="col-md-6">
          {order?.is_paid ? (
            <PaymentSuccess order={order} />
          ) : (
            <PaymentForm
              totals={order.totals}
              user={user!}
              onSuccess={paymentSuccess}
              setError_message={setError_message}
              order_id={order_id}
            />
          )}
        </div>

        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h4>Resumen de la orden</h4>
              <Products data={order.products} />

              <div className="d-flex justify-content-between">
                <span>Total</span>
                <span>${formatNumber(order.totals.total)}</span>
              </div>
              <hr />
              {order.totals.shipping ? (
                <div className="d-flex justify-content-between">
                  <span>Envío</span>
                  <span>${formatNumber(order.totals.shipping)}</span>
                </div>
              ) : null}
              <div className="d-flex justify-content-between">
                <span>Subtotal</span>
                <span>${formatNumber(order.totals.subtotal)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span>IVA</span>
                <span>${formatNumber(order.totals.tax || 0)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

type ProductsProps = {
  data: OrderPrductItem[];
};
const Products: React.FC<ProductsProps> = ({ data }) => {
  return (
    <table className="table table-striped ">
      <thead>
        <tr>
          <th scope="col">Producto</th>
          <th scope="col">Qty</th>
          <th scope="col">Precio</th>
        </tr>
      </thead>
      {data.map((product) => (
        <tr key={`table_${product.id}`} className="">
          <th scope="row">
            <a
              href={`/producto/${product.id}`}
              target="_blank"
              rel="noreferrer"
            >
              {product.title}
            </a>
          </th>
          <td>{product.qty}</td>
          <td>${formatNumber(product.price)}</td>
        </tr>
      ))}
    </table>
  );
};

export default PaymentPage;
